export const GET_NEWS_BEGIN = "GET_NEWS_BEGIN";
export const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS";
export const GET_NEWS_ERROR = "GET_NEWS_ERROR";

export const GET_NEWS_SINGLE_BEGIN = "GET_NEWS_SINGLE_BEGIN";
export const GET_NEWS_SINGLE_SUCCESS = "GET_NEWS_SINGLE_SUCCESS";
export const GET_NEWS_SINGLE_ERROR = "GET_NEWS_SINGLE_ERROR";
